var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05Tuusin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F90133;}\n\t.st1{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,9c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.2,0.7,2.2,1.7,2.7L6,28h16l-6.7-16.3C16.3,11.2,17,10.2,17,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,14.2l1.2-1.7C8.4,11.5,8,10.3,8,9s0.4-2.5,1.1-3.5L7.9,3.8C6.7,5.2,6,7,6,9S6.7,12.8,7.9,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,0.5l-1.2,1.7C22.9,3.9,24,6.3,24,9s-1.1,5.1-2.8,6.9l1.2,1.7C24.6,15.4,26,12.3,26,9S24.6,2.6,22.4,0.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,14.2C21.3,12.8,22,11,22,9s-0.7-3.8-1.9-5.2l-1.2,1.7C19.6,6.5,20,7.7,20,9s-0.4,2.5-1.1,3.5L20.1,14.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,9c0-2.7,1.1-5.1,2.8-6.9L5.6,0.5C3.4,2.6,2,5.7,2,9s1.4,6.4,3.6,8.5l1.2-1.7C5.1,14.1,4,11.7,4,9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05Tuusin);
export default __webpack_public_path__ + "static/media/05_tuusin.83a51d114452c997fc3d11555d3d9417.svg";
export { ForwardRef as ReactComponent };